import FormLabel from '@zenbusiness/zui/FormLabel';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const FieldLabel = superstyled({
  name: 'FieldHeading',
  slot: 'FieldLabel',
  tag: FormLabel,
  styles: ({ theme }) => ({
    marginBlockEnd: theme.spacing(0),
    // Override error state color to use primary color
    '&.Mui-error': {
      color: theme.palette.primary.main
    },
    // Hide the asterisk symbol
    '& .MuiFormLabel-asterisk': {
      display: 'none'
    }
  })
});
